import { fetchApiClient } from '@/api/fetchers/fetchApiClient';
import { bakstaApiEndpoint } from '@/global/public-settings';

import { ApiResponse } from './data';

export function getRates(): Promise<ApiResponse | null> {
  return fetchApiClient<ApiResponse>(`https://${bakstaApiEndpoint}/v2/rates`);
}
